// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5012b394].el-input--small {\n  font-size: 12px !important;\n}\n.label[data-v-5012b394] {\n  font-size: 12px;\n  color: #999;\n}\n.c_row-item[data-v-5012b394] {\n  margin-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
